<template>
  <div class="tito-ticket-details-activity-question">
    <label
      class="tito-ticket-details-activity-question--label"
      :for="'tito-question' + activityGroup.id"
    >
      <span class="tito-required" v-if="isRequired">* </span>{{ name }}
    </label>

    <div
      class="tito-ticket-details-activity-question--description markdown"
      v-if="description"
      v-html="description"
    />

    <p v-if="selectionLimit">{{ selectionLimit }}</p>

    <details v-for="optionalActivity in optionalActivities">
      <summary
        :class="
          optionalActivity.description
            ? ''
            : 'tito-ticket-details-activity-question--no-description'
        "
      >
        <label class="tito-ticket-details-activity-question--checkbox">
          <input
            v-model="optionalActivityId"
            v-if="isRadio"
            else
            type="radio"
            :value="optionalActivity.id"
          />
          <input
            v-model="optionalActivityIds"
            v-else
            type="checkbox"
            :value="optionalActivity.id"
          />
          {{ translate(optionalActivity, "name") }}
        </label>
        <font-awesome-icon
          :icon="['fas', 'caret-left']"
          class="fa-xl"
          fixed-width
          v-if="optionalActivity.description"
        />
      </summary>
      <p
        class="tito-ticket-details-activity-group--description"
        v-if="optionalActivity.description"
        v-html="translate(optionalActivity, 'description')"
      />
    </details>
  </div>
</template>

<script>
import translate from "js/src/mixins/translate.js";
import validation from "js/src/directives/validation.js";

export default {
  directives: { validation },
  mixins: [translate],
  props: ["activityGroup", "value", "locale"],

  data() {
    return {
      optionalActivityIds: this.activityGroup.chosen_activity_ids,
      optionalActivityId: this.activityGroup.chosen_activity_ids[0] || null,
    };
  },

  watch: {
    optionalActivityIds() {
      this.emitValue();
    },

    optionalActivityId() {
      this.emitValue();
    },
  },

  computed: {
    description() {
      return this.translate(this.activityGroup, "description");
    },

    isRadio() {
      return this.activityGroup.max_activities_per_ticket == 1;
    },

    isRequired() {
      return (
        this.activityGroup.min_activities_per_ticket &&
        this.activityGroup.min_activities_per_ticket > 0
      );
    },

    optionalActivities() {
      let out = this.activityGroup.allocatable_public_optional_activities;
      if (
        this.activityGroup.max_activities_per_ticket == 1 &&
        this.activityGroup.min_activities_per_ticket != 1 &&
        !out.some((optionalActivity) => optionalActivity.id == null)
      ) {
        let noneOption = { id: null, name: "None" };
        noneOption["translations"] = {};
        noneOption["translations"][this.locale] = {
          name: this.$t("activity_groups.none", this.locale),
        };
        out.unshift(noneOption);
      }
      return out;
    },

    name() {
      return this.translate(this.activityGroup, "name");
    },

    selectionLimit() {
      const max = this.activityGroup.max_activities_per_ticket;
      const min = this.activityGroup.min_activities_per_ticket;
      if (
        min &&
        (min == this.activityGroup.public_optional_activities.length ||
          min == max)
      ) {
        return this.$t("activity_groups.please_select_exact", this.locale, {
          amount: max || min,
        });
      } else if (min && max) {
        return this.$t("activity_groups.please_select_range", this.locale, {
          max_activities_per_ticket: max,
          min_activities_per_ticket: min,
        });
      } else if (max) {
        return this.$t("activity_groups.please_select_max", this.locale, {
          max_activities_per_ticket: max,
        });
      } else if (min) {
        return this.$t("activity_groups.please_select_at_least", this.locale, {
          min_activities_per_ticket: min,
        });
      }
    },
  },

  methods: {
    emitValue() {
      this.$emit(
        "input",
        this.isRadio ? [this.optionalActivityId] : this.optionalActivityIds,
      );
    },
  },
};
</script>
